import React from 'react'
// components
import { ReduxInput } from 'components/FormElements'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AccordionOrigin from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
// constants
import { PANEL_STYLES } from '../UserData'
// themes
import { colors } from 'themes/index'
// views
import { FieldsContainer } from '../OrganizationData/views'
// utils
import { minValue300 } from 'utils/validators'

const TokenConfiguration: React.FC = () => {
  return (
    <AccordionOrigin>
      <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor={colors.blue500} />}>
        Token Configuration
      </AccordionSummary>
      <AccordionDetails style={PANEL_STYLES}>
        <FieldsContainer>
          <ReduxInput
            label='Refresh Token Absolute TTL (seconds)'
            name='refreshTokenAbsoluteTtl'
            type='number'
            validate={minValue300}
          />
          <ReduxInput label='Idle Timeout (seconds)' name='idleTimeoutSeconds' type='number' validate={minValue300} />
        </FieldsContainer>
      </AccordionDetails>
    </AccordionOrigin>
  )
}

export default TokenConfiguration
